<script lang="ts">
  import { navigate } from "../../app.logic";
  // import UserTimeStats from "../../components/Business/UserTimeStats.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import { formatTimestampHuman } from "../../utils/date-utils";
  import { progettoAzioniDtoFields } from "../../utils/TableFields/project-action-dto.fields";
  //  import { Modals, closeModal } from 'svelte-modals';
  import CreateActionModal from "./CreateActionModal.svelte";
  $: tableFields = [...progettoAzioniDtoFields];

  import {
    clearSearchAction,
    filterActions,
    initDetail,
    onExportProjectActions,
    onPageChangeProjectAction,
    paginationActions,
    record,
    recordsActions,
    searchAction,
    showDetailAction,
    createNewAction,
    showModalAction,
    modalDataAction,
    tasks,
    showModal,
    modalData,
    saveAction,
    deleteAction,
  } from "./project.store";
  import { Table } from "../../components/Table";
  import { onMount } from "svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import DateInput from "../../components/Form/Fields/DateInput.svelte";
  import Button from "../../components/Button.svelte";
  import Icon from "../../components/Icon.svelte";
  import ProjectStatesDropdown from "../../components/Business/ProjectStatesDropdown.svelte";
  import Tab from "../../components/Tab/Tab.svelte";
  import Tabs from "../../components/Tab/Tabs.svelte";
  import Gantt from "../../components/Business/Gantt.svelte";
  import type { from } from "rxjs";
  import ConfirmModal from "../../components/Modal/ConfirmModal.svelte";
  import type { IProjectAction } from "../../entities/project-action";
  import { get } from "svelte/store";

  export let oid: number;
  let action: IProjectAction;

  enum ProjectActionPage {
    List = 1,
    GANTT,
  }

  let currentTab: ProjectActionPage = ProjectActionPage.List;

  let showCreateActionModal = false;

  function onCreate(data) {
    action = createEmptyAction(data);
    showCreateActionModal = true;
  }

  function onEdit(data) {
    action = createModalAction(data);
    showCreateActionModal = true;
  }

  function closeCreateModal() {
    showCreateActionModal = false;
  }

  async function handleActionCreated(data) {
    if (!data) return;
    
    if (data.posizione === "prima"){
      data.parentAction = data.parentAction-10;
    }
    else if (data.posizione === "dopo"){
      data.parentAction = data.parentAction;
    }
    else {
      data.parentAction = data.codiceAzione;
    }
  
    data.codiceAzione = data.parentAction;
    await saveAction(data);
    showCreateActionModal = false;
  }

  function createEmptyAction(data): IProjectAction {
    return {
      posizione: "dopo",
      parentAction: data.codiceAzione,
      origin: "CRM",
      oid: oid.toString(),
      codiceCommessa: oid,
      stato: "",
      gestioneSeparata: "",
      codiceProgetto: "",
      titolo: "",
      descrizioneAzione: "",
      iDAzioneFIMAA39: "",
      hub: "",
      riferimentoNote: "",
      ore: 0,
      tipologiaOre: "",
      descrTipoIntervento: "",
      uffcompetenza: "",
      statoazione: "",
      pianificato: 0,
      erogato: 0,
      annullato: "",
      partecipantiAttesi: 0,
      costoStandard1: 0,
      costoStandard2: 0,
      budget: 0,
      monitoraggioEffettuato: "",
      oreFinali: 0,
      partecipantiFinali: 0,
      totalerendicontato: 0,
      tipoRendiconto: "",
      decurtazione: 0,
      dataStato: new Date(),
      dataFine: new Date(),
      dataInizio: new Date(),
      ragsoc1: "",
      ragsoc2: "",
      ragsoc3: "",
      ragsoc4: "",
      ragsoc5: "",
      ragsoc6: "",
    };
  }

  export function getFirstAvailableCodiceAzione(
    baseCodice: number,
  ): number | false {
    const actions = get(recordsActions);

    const existing = new Set(
      actions.map((a) => Number(a.codiceAzione)).filter((n) => !isNaN(n)),
    );

    for (let i = 1; i <= 9; i++) {
      const candidate = baseCodice + i;
      if (!existing.has(candidate)) {
        return candidate;
      }
    }

    return false;
  }

  export function formatDateForInput(
    date: Date | string | null | undefined,
  ): string {
    if (!date) return "";
    const d = typeof date === "string" ? new Date(date) : date;
    return d.toISOString().split("T")[0];
  }

  export function parseInputToDate(str: string): Date | null {
    if (!str) return null; // if input is empty, return null
    return new Date(`${str}T00:00:00`);
  }

  function createModalAction(action: IProjectAction): IProjectAction {
    return action;
  }

  function onCancel() {
    navigate(`/project`);
  }

  onMount(() => {
    initDetail(oid).then(() => {
      let client_size =
        window.document.getElementsByClassName("main-layout-content")[0]
          .offsetWidth - 60;
      window.document.getElementById("table_container").style.width =
        client_size + "px";
    });
  });

  function formatDialogMessage(record: IProjectAction): string {
    let ret = "";
    if (record) {
      const clienti = [
        record.ragsoc1,
        record.ragsoc2,
        record.ragsoc3,
        record.ragsoc4,
        record.ragsoc5,
        record.ragsoc6,
      ];
      for (let i = 0; i < clienti.length; i++) {
        if (clienti[i]) {
          if (ret != "") {
            ret += ",";
          }
          ret += clienti[i];
        }
      }
    }

    return ret != "" ? ret : "Nessuna azienda partecipante";
  }
</script>

<MainLayout>
  {#if $record}
    <div class="columns">
      <div class="column is-12">
        <FormLayout
          submitEnabled={false}
          canSubmit={false}
          isNew={false}
          on:cancel={onCancel}
          cancelButtonText="Indietro"
        >
          <div class="columns">
            <div class="column is-4">
              <FormField>
                <Input
                  name="Titolo"
                  placeholder="Titolo"
                  bind:value={$record.progetto.titoloProgetto}
                  disabled={true}
                />
              </FormField>
            </div>

            <div class="column is-3">
              <FormField>
                <Input
                  name="Cliente"
                  placeholder="Cliente"
                  bind:value={$record.progetto.cliente}
                  disabled={true}
                />
              </FormField>
            </div>

            <div class="column is-2">
              <FormField>
                <Input
                  name="Codice Progetto"
                  placeholder="Codice progetto"
                  bind:value={$record.progetto.codiceProgetto}
                  disabled={true}
                />
              </FormField>
            </div>

            <div class="column is-3">
              <FormField>
                <Input
                  name="Risorsa responsabile"
                  placeholder="Risorsa responsabile"
                  bind:value={$record.progetto.risorsaResponsabile}
                  disabled={true}
                />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column is-2">
              <FormField>
                <Input
                  name="Data partenza prev."
                  placeholder=""
                  required={false}
                  readonly={true}
                  disabled={true}
                  value={$record.progetto.dataPartenzaPrevista != null
                    ? formatTimestampHuman(
                        $record.progetto.dataPartenzaPrevista,
                      )
                    : ""}
                />
              </FormField>
            </div>
            <div class="column is-2">
              <FormField>
                <Input
                  name="Data inizio"
                  placeholder=""
                  required={false}
                  readonly={true}
                  disabled={true}
                  value={$record.progetto.dataInizioProgetto != null
                    ? formatTimestampHuman($record.progetto.dataInizioProgetto)
                    : ""}
                />
              </FormField>
            </div>
            <div class="column is-2">
              <FormField>
                <Input
                  name="Data fine"
                  placeholder=""
                  required={false}
                  readonly={true}
                  disabled={true}
                  value={$record.progetto.dataFineProgetto != null
                    ? formatTimestampHuman($record.progetto.dataFineProgetto)
                    : ""}
                />
              </FormField>
            </div>
            <div class="column is-2">
              <FormField>
                <Input
                  name="Data rendicontazione"
                  placeholder=""
                  required={false}
                  readonly={true}
                  disabled={true}
                  value={$record.progetto.dataRendicontazione != null
                    ? formatTimestampHuman($record.progetto.dataRendicontazione)
                    : ""}
                />
              </FormField>
            </div>

            <div class="column is-2">
              <FormField>
                <Input
                  name="Data ult. agg."
                  placeholder=""
                  required={false}
                  readonly={true}
                  disabled={true}
                  value={$record.progetto.dataUltimoAggiornamento != null
                    ? formatTimestampHuman(
                        $record.progetto.dataUltimoAggiornamento,
                      )
                    : ""}
                />
              </FormField>
            </div>
          </div>

          <SearchHeader
            entitySingular={"azione"}
            entityPlural={"azioni"}
            numRecords={$paginationActions != null
              ? $paginationActions.totalRecords
              : 0}
            bind:searchValue={$filterActions.criteria.query}
            on:search={searchAction}
          >
            <div slot="search" class="level">
              <div class="level-item">
                <div>
                  <FormField>
                    <DateInput
                      name=""
                      placeholder="Data Inizio"
                      required={false}
                      bind:value={$filterActions.criteria.dataFrom}
                    />
                  </FormField>
                </div>
              </div>

              <div class="level-item">
                <div>
                  <FormField>
                    <DateInput
                      name=""
                      placeholder="Data Fine"
                      required={false}
                      bind:value={$filterActions.criteria.dataTo}
                    />
                  </FormField>
                </div>
              </div>

              <div class="level-item">
                <div>
                  <FormField>
                    <ProjectStatesDropdown
                      name=""
                      placeholder="Filtra per stato..."
                      required={false}
                      bind:value={$filterActions.criteria.stato}
                      on:select={searchAction}
                    />
                  </FormField>
                </div>
              </div>

              <div class="level-item">
                <p class="control">
                  <Button on:click={searchAction}>
                    <Icon name="search" />

                    <span> Cerca </span>
                  </Button>
                </p>
              </div>

              <div class="level-item">
                <p class="control">
                  <Button on:click={clearSearchAction}>Azzera</Button>
                </p>
              </div>
            </div>
          </SearchHeader>

          <Tabs>
            <Tab
              label="Lista azioni"
              active={currentTab == ProjectActionPage.List}
              on:click={(_) => {
                currentTab = ProjectActionPage.List;
                let client_size =
                  window.document.getElementsByClassName(
                    "main-layout-content",
                  )[0].offsetWidth - 60;
                console.log(client_size);
                window.document.getElementById("table_container").style.width =
                  client_size + "px";
                window.document.getElementById(
                  "table_container",
                ).style.overflowX = "scroll";
              }}
            />
            <Tab
              label="GANTT azioni"
              active={currentTab == ProjectActionPage.GANTT}
              on:click={(_) => {
                currentTab = ProjectActionPage.GANTT;
                let client_size =
                  window.outerWidth - (window.outerWidth < 1600 ? 310 : 400);
                console.log(client_size);
                window.document.getElementById("table_container").style.width =
                  client_size + "px";
                window.document.getElementById(
                  "table_container",
                ).style.overflowX = "hidden";
              }}
            />
          </Tabs>
          <div id="table_container" style="width: 1000px;overflow-x: scroll;">
            {#if currentTab == ProjectActionPage.List}
              <Table
                loading={false}
                fields={tableFields}
                records={$recordsActions}
                pagination={$paginationActions}
                createEnabled={(record) => record.origin === "ERP"}
                editEnabled={(record) => record.origin === "CRM"}
                showEnabled={true}
                deleteEnabled={(record) => record.origin === "CRM"}
                exportEnabled={true}
                on:pageChange={(e) => onPageChangeProjectAction(e.detail)}
                on:export={(e) => onExportProjectActions()}
                on:edit={(e) => onEdit(e.detail)}
                on:show={(e) => showDetailAction(e.detail)}
                on:create={(e) => onCreate(e.detail)}
                on:delete={(e) => deleteAction(e.detail)}
              />
            {/if}

            {#if currentTab == ProjectActionPage.GANTT}
              {#if $tasks.length > 0}
                <Gantt tasks={$tasks} />
              {:else}
                <div class="notification is-info">
                  Non sono presenti azioni con almeno la <strong
                    >data di inizio impostata</strong
                  >, non è possibile generare un grafico GANTT
                </div>
              {/if}
            {/if}
          </div>
        </FormLayout>
      </div>
    </div>
  {/if}

  <!--Modals>
  <div slot="backdrop" class="backdrop" on:click={closeModal} />
</Modals-->
</MainLayout>
<ConfirmModal
  title={"Aziende partecipanti all'azione " + $modalData?.codiceAzione}
  confirmButtonText={"Chiudi"}
  message={formatDialogMessage($modalData)}
  bind:open={$showModal}
  on:confirm={() => ($showModal = false)}
  showDeclineButton={false}
/>

<CreateActionModal
  bind:open={showCreateActionModal}
  {action}
  on:close={closeCreateModal}
  on:save={(e) => handleActionCreated(e.detail)}
/>

<style>
  .backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
  }

  :global .large-table {
    min-width: 4000px;
  }
</style>
